var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "draggable",
        {
          staticStyle: { cursor: "grab" },
          attrs: { options: { disabled: _vm.modeEdit || _vm.modeCreate } },
          on: { change: _vm.changePositionList },
          model: {
            value: _vm.tempDataWidget,
            callback: function($$v) {
              _vm.tempDataWidget = $$v
            },
            expression: "tempDataWidget"
          }
        },
        _vm._l(_vm.dataWidgetList, function(val, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "widget-box",
              class: {
                "card-attendance":
                  val.widget_master.name === "attendance" && !_vm.isAttended,
                "card-not-attendance":
                  val.widget_master.name === "attendance" && _vm.isAttended,
                "card-timesheet": val.widget_master.name === "timesheet",
                "card-leave":
                  val.widget_master.name === "quota_leave" ||
                  val.widget_master.name === "leave_all_employee",
                "card-mode-edit": val.widget_master.mode_edit === true
              }
            },
            [
              val.widget_master.mode_edit === true
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c("j-widget-component-edit", {
                            attrs: {
                              "data-master": _vm.dataMaster,
                              "mode-create": _vm.modeCreate,
                              "mode-edit": _vm.modeEdit,
                              "data-edit": _vm.dataEdit
                            },
                            on: {
                              "close-field": function($event) {
                                _vm.closeModeEdit(index)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c(
                    "b-row",
                    [
                      val.widget_master.name === "attendance"
                        ? _c(
                            "b-col",
                            { staticClass: "pl-0 pr-0" },
                            [
                              _c("j-attendance-widget", {
                                attrs: {
                                  element: val,
                                  "data-attendance": _vm.dataAttendance,
                                  "is-attended": _vm.isAttended
                                }
                              })
                            ],
                            1
                          )
                        : val.widget_master.name === "timesheet"
                        ? _c(
                            "b-col",
                            [
                              _c("j-timesheet-widget", {
                                attrs: {
                                  element: val,
                                  "detail-timesheet": _vm.detailTimesheet
                                }
                              })
                            ],
                            1
                          )
                        : val.widget_master.name === "discussion"
                        ? _c(
                            "b-col",
                            [
                              _c("j-discussion-widget", {
                                attrs: { element: val }
                              })
                            ],
                            1
                          )
                        : val.widget_master.name === "channel"
                        ? _c(
                            "b-col",
                            [
                              _c("j-discussion-widget", {
                                attrs: { element: val }
                              })
                            ],
                            1
                          )
                        : val.widget_master.name === "html"
                        ? _c(
                            "b-col",
                            [_c("j-html-widget", { attrs: { element: val } })],
                            1
                          )
                        : val.widget_master.name === "create_record"
                        ? _c(
                            "b-col",
                            [
                              _c("j-create-record-widget", {
                                attrs: { element: val }
                              })
                            ],
                            1
                          )
                        : val.widget_master.name === "analytic_v2"
                        ? _c(
                            "b-col",
                            [_c("j-html-widget", { attrs: { element: val } })],
                            1
                          )
                        : val.widget_master.name === "quota_leave"
                        ? _c(
                            "b-col",
                            [
                              _c(
                                "b-row",
                                [
                                  _c("b-col", { attrs: { cols: "12" } }, [
                                    _c("h4", [_vm._v("MY LEAVE QUOTA")])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticStyle: {
                                        "max-height": "330px",
                                        "overflow-y": "auto"
                                      },
                                      attrs: { cols: "12" }
                                    },
                                    [
                                      _c(
                                        "b-row",
                                        { staticClass: "content-quota-leave" },
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _vm.list_quota_leave.length === 0
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c("jLottie", {
                                                        staticClass:
                                                          "animation",
                                                        attrs: {
                                                          options:
                                                            _vm.defaultOptions,
                                                          height: 400,
                                                          width: 420
                                                        },
                                                        on: {
                                                          animCreated:
                                                            _vm.handleAnimation
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _c("j-quota-leave-widget", {
                                                    attrs: {
                                                      element: val,
                                                      "quota-leave":
                                                        _vm.list_quota_leave
                                                    }
                                                  })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : val.widget_master.name === "leave_all_employee"
                        ? _c(
                            "b-col",
                            [
                              _c("j-leave-all-employee-widget", {
                                attrs: { element: val }
                              })
                            ],
                            1
                          )
                        : val.widget_master.name === "experience_manager"
                        ? _c(
                            "b-col",
                            [
                              _vm.show_calendar_view
                                ? _c("j-calender-view-widget", {
                                    attrs: {
                                      element: val,
                                      "form-data": _vm.calenderViewData.find(
                                        function(c) {
                                          return c.id === val.id
                                        }
                                      ).form_data,
                                      "form-ui": _vm.calenderViewData.find(
                                        function(c) {
                                          return c.id === val.id
                                        }
                                      ).form_ui,
                                      "on-widget": true
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : val.widget_master.name === "shortcut_page"
                        ? _c(
                            "b-col",
                            [
                              _c("j-shortcut-page-widget", {
                                attrs: { element: val }
                              })
                            ],
                            1
                          )
                        : _c("b-col", { attrs: { md: "6" } }, [
                            _c("h4", [
                              _vm._v(
                                _vm._s(val.widget_master.name.toUpperCase())
                              )
                            ]),
                            _vm._v(" "),
                            _c("label", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    JSON.parse(val.info).name
                                      ? JSON.parse(val.info).name
                                      : val.widget_master.name
                                  ) +
                                  "\n          "
                              )
                            ])
                          ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "edit-or-delete" }, [
                        _vm.widgetReadyList.includes(val.widget_master.name) &&
                        val.widget_master.name !== "attendance"
                          ? _c("i", {
                              staticClass: "fa fa-pencil-square-o",
                              on: {
                                click: function($event) {
                                  _vm.onClickEdit(index, val.id)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-trash-o",
                          on: {
                            click: function($event) {
                              _vm.onClickDelete(index)
                            }
                          }
                        })
                      ])
                    ],
                    1
                  )
            ],
            1
          )
        })
      ),
      _vm._v(" "),
      !_vm.modeCreate
        ? _c(
            "div",
            {
              staticClass: "card-field-widget card-add-widget left-add-widget"
            },
            [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.hide,
                      expression: "hide"
                    }
                  ],
                  staticClass: "btn btn-block btn-add-widget",
                  attrs: { id: "popover-button-event" },
                  on: { click: _vm.toogle }
                },
                [
                  _c("div", { staticClass: "text-center" }, [
                    _vm._v("\n        +\n      ")
                  ])
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.opened,
              expression: "opened"
            }
          ],
          staticClass: "card-master-widget-container"
        },
        [
          _c("div", { staticClass: "card-select-widget" }, [
            _vm._v("\n      SELECT WIDGET\n    ")
          ]),
          _vm._v(" "),
          _vm._l(_vm.dataWidgetMaster, function(val, index) {
            return _c("div", { key: index }, [
              _c(
                "div",
                {
                  staticClass: "cursor-dropdown",
                  on: {
                    click: function($event) {
                      _vm.chooseMaster(val)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        val.name
                          .split("_")
                          .join(" ")
                          .toUpperCase()
                      ) +
                      "\n      "
                  )
                ]
              )
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("j-widget-component-create", {
        attrs: {
          "data-master": _vm.dataMaster,
          "mode-create": _vm.modeCreate,
          "mode-edit": _vm.modeEdit,
          "data-edit": _vm.dataEdit
        },
        on: { "close-field": _vm.closeModeCreate }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d084ee4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d084ee4a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/widget/jWidgetList.vue
// module id = null
// module chunks = 